import React from 'react';
import { observer } from 'mobx-react';
import { ButtonClickEvent } from 'ui/base/types';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import { SiteFilter } from 'services/pangolin/types';
import { getSiteFilterIcon, getSiteFilterLabel } from './site_entry_logic';
import baseStyles from './site_entry.module.css';

type SiteEntryStyles = {
  plainContainer: string;
  clickableContainer: string;
  iconContainer: string;
  detailContainer: string;
  detailText: string;
  bareButton: string;
  removeIcon: string;

  // Filter-specific icons
  domainIcon: string;
  hostIcon: string;
  networkIcon: string;
};

const themedStyles: ThemedStyles<SiteEntryStyles> = {
  [Theme.DAYLIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    detailText: baseStyles.detailText,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,

    // Filter-specific icons
    domainIcon: baseStyles.daylightDomainIcon,
    hostIcon: baseStyles.daylightHostIcon,
    networkIcon: baseStyles.daylightNetworkIcon,
  },
  [Theme.MIDNIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    detailText: baseStyles.detailText,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,

    // Filter-specific icons
    domainIcon: baseStyles.midnightDomainIcon,
    hostIcon: baseStyles.midnightHostIcon,
    networkIcon: baseStyles.midnightNetworkIcon,
  },
};

type RemovableSiteEntryProps = {
  entry: SiteFilter;
  onRemoveClick: (event: ButtonClickEvent) => void;
};

export const RemovableSiteEntry = observer(({ entry, onRemoveClick }: RemovableSiteEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <div className={getSiteFilterIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getSiteFilterLabel(entry)}
        </div>
        <button type='button' className={styles.bareButton} onClick={onRemoveClick}>
          <div className={styles.removeIcon}/>
        </button>
      </div>
    </div>
  );
});

export type SearchSiteEntryProps = {
  data: SiteFilter;
  onSelect: () => void;
};

export const SearchSiteEntry = observer(({ data: entry, onSelect }: SearchSiteEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.clickableContainer} onClick={onSelect}>
      <div className={styles.iconContainer}>
        <div className={getSiteFilterIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getSiteFilterLabel(entry, true)}
        </div>
      </div>
    </div>
  );
});


export type PlainSiteEntryProps = {
  entry: SiteFilter;
};
export const PlainSiteFilter = observer(({ entry }: PlainSiteEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <div className={getSiteFilterIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getSiteFilterLabel(entry)}
        </div>
      </div>
    </div>
  );
});
